// extracted by mini-css-extract-plugin
module.exports = {"footerContainer":"ClientWallet_footerContainer__19ZSD","savePackageButton":"ClientWallet_savePackageButton__2wO6d"};